import { c as _c } from "react/compiler-runtime";
import { Avatar, Box, Button, Heading, HStack, Text, VStack } from '@chakra-ui/react';
import { Global, css } from '@emotion/react';
import { hourSeed, seededShuffle } from '@src/lib/seededShuffle';
import React from 'react';
const scrollAnimationStyles = css`
  @keyframes request-lp-card-scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;
const renderCardSet = (keyPrefix: string) => {
  const shuffled = seededShuffle(RequestCardContentArray, hourSeed());
  return shuffled.map((item, index) => <RequestLPCard key={`${keyPrefix}-${index}`} colorHexCode={item.colorHexCode} displayTitle={item.displayTitle} requestingUser={item.requestingUser} title={item.title} />);
};
export const RequestLPCardScroll: React.FC = props => {
  const $ = _c(11);
  const t0 = `linear-gradient(to right, ${props.gradientEndColor || "{colors.colorPalette.panel}"}, transparent)`;
  const t1 = `linear-gradient(to right, ${props.gradientEndColor || "{colors.colorPalette.panel}"}, transparent)`;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = <Box height="full" left={0} position="absolute" top={0} width="80px" zIndex="docked" bg={{
      _light: t0,
      _dark: t1
    }} />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `linear-gradient(to left, ${props.gradientEndColor || "{colors.colorPalette.panel}"}, transparent)`;
  const t4 = `linear-gradient(to left, ${props.gradientEndColor || "{colors.colorPalette.panel}"}, transparent)`;
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = <Box height="full" position="absolute" right={0} top={0} width="80px" zIndex="docked" bg={{
      _light: t3,
      _dark: t4
    }} />;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Global styles={scrollAnimationStyles} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <HStack align="stretch" animation="request-lp-card-scroll 90s linear infinite" flexShrink={0} gap={6} width="max-content">{renderCardSet("a")}{renderCardSet("b")}</HStack>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t2 || $[9] !== t5) {
    t8 = <VStack align="stretch" gap={6} width="full"><Box overflow="hidden" position="relative" width="full">{t2}{t5}{t6}{t7}</Box></VStack>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};
const RequestLPCard = props => {
  const $ = _c(27);
  const t0 = `linear-gradient(to bottom, ${props.colorHexCode}50 0%, ${props.colorHexCode}25 100%)`;
  const t1 = props.title || "Request";
  let t2;
  if ($[0] !== props.colorHexCode || $[1] !== t1) {
    t2 = <HStack><Button bgColor={props.colorHexCode} size="xs">{t1}</Button></HStack>;
    $[0] = props.colorHexCode;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props.displayTitle) {
    t3 = <Heading size="lg">{props.displayTitle}</Heading>;
    $[3] = props.displayTitle;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.requestingUser.displayName) {
    t4 = <Avatar.Fallback color="white" name={props.requestingUser.displayName} />;
    $[5] = props.requestingUser.displayName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props.colorHexCode || $[8] !== t4) {
    t5 = <Avatar.Root bgColor={props.colorHexCode} size="md">{t4}</Avatar.Root>;
    $[7] = props.colorHexCode;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== props.requestingUser.displayName) {
    t6 = <Heading fontSize="sm">{props.requestingUser.displayName}</Heading>;
    $[10] = props.requestingUser.displayName;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = props.requestingUser.company?.name;
  let t8;
  if ($[12] !== t7) {
    t8 = <Text fontSize="xs">{t7}</Text>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <VStack align="stretch" flex={1} gap={0}>{t6}{t8}</VStack>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t5 || $[18] !== t9) {
    t10 = <HStack gap={4}>{t5}{t9}</HStack>;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t2 || $[22] !== t3) {
    t11 = <Box borderRadius="md" height="full"><VStack align="stretch" gap={2} height="full" justify="space-between">{t2}{t3}{t10}</VStack></Box>;
    $[20] = t10;
    $[21] = t2;
    $[22] = t3;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t0 || $[25] !== t11) {
    t12 = <Box bg={t0} bgColor="bg.darker" borderRadius="xl" boxShadow="md" flexShrink={0} marginY={4} padding={6} width="340px">{t11}</Box>;
    $[24] = t0;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};
const RequestCardContentArray = [{
  colorHexCode: '#38908A',
  title: 'Raise Funding',
  displayTitle: 'Seed Funding Opportunity: B2B SaaS Startup Seeking $750K',
  requestingUser: {
    displayName: 'Michael R.',
    company: {
      name: 'B2B SaaS Platform'
    }
  }
}, {
  colorHexCode: '#38908A',
  title: 'Raise Funding',
  displayTitle: 'Reworking a Seed Pitch Deck for a Pre-Revenue Fintech Startup',
  requestingUser: {
    displayName: 'Sofia M.',
    company: {
      name: 'Fintech Startup'
    }
  }
}, {
  colorHexCode: '#BE4444',
  title: 'Get Customers',
  displayTitle: 'Growth Marketer Needed to Acquire First 1,000 SMB Customers',
  requestingUser: {
    displayName: 'Jason P.',
    company: {
      name: 'SMB Software'
    }
  }
}, {
  colorHexCode: '#BE4444',
  title: 'Get Customers',
  displayTitle: 'Building a Go-To-Market Plan for a Direct-to-Consumer Brand',
  requestingUser: {
    displayName: 'Emily A.',
    company: {
      name: 'DTC Consumer Brand'
    }
  }
}, {
  colorHexCode: '#385564',
  title: 'Build Product',
  displayTitle: 'Full-Stack Product Partner Needed to Build SaaS MVP',
  requestingUser: {
    displayName: 'Ji-Hoon P.',
    company: {
      name: 'Workflow SaaS'
    }
  }
}, {
  colorHexCode: '#385564',
  title: 'Build Product',
  displayTitle: 'Product Designer Needed for Consumer App Launch',
  requestingUser: {
    displayName: 'Sarah D.',
    company: {
      name: 'Mobile App Startup'
    }
  }
}, {
  colorHexCode: '#872341',
  title: 'Find a Co-Founder',
  displayTitle: 'Technical Co-Founder Wanted for AI-Driven SaaS Platform',
  requestingUser: {
    displayName: 'Rohan S.',
    company: {
      name: 'AI SaaS Startup'
    }
  }
}, {
  colorHexCode: '#872341',
  title: 'Find a Co-Founder',
  displayTitle: 'Seeking a Co-Founder With Seed Fundraising Experience',
  requestingUser: {
    displayName: 'Laura V.',
    company: {
      name: 'Marketplace Startup'
    }
  }
}, {
  colorHexCode: '#4A47A3',
  title: 'Find Advisors',
  displayTitle: 'Advisor With Investor Introductions for Upcoming Seed Round',
  requestingUser: {
    displayName: 'Mark B.',
    company: {
      name: 'Enterprise Software'
    }
  }
}, {
  colorHexCode: '#4A47A3',
  title: 'Find Advisors',
  displayTitle: 'Sales Advisor to Help Build First Outbound Team',
  requestingUser: {
    displayName: 'Carlos F.',
    company: {
      name: 'B2B Services Company'
    }
  }
}, {
  colorHexCode: '#46B5D1',
  title: 'Hire Talent',
  displayTitle: 'Hiring First Senior Backend Engineer for Fintech Startup',
  requestingUser: {
    displayName: 'Daniel W.',
    company: {
      name: 'Fintech Platform'
    }
  }
}, {
  colorHexCode: '#46B5D1',
  title: 'Hire Talent',
  displayTitle: 'Planning the First 5 Hires at an Early-Stage Marketplace',
  requestingUser: {
    displayName: 'Rachel C.',
    company: {
      name: 'Online Marketplace'
    }
  }
}];